<template>
<main class="main-wrapper flex-grow-1 bg-documentGray">
						<div class="d-flex align-items-center ">
								<div class="t-headline13 t-color-headlineBlack pda-14 font-m flex-grow-1 bg-white fix-header-title d-flex align-items-center justify-content-center">
										<div class="font-m">{{this.$t('1893')}}</div>
								</div>
						</div>
						<div class="divider"></div>
						<!-- subtabs -->
						<div class="shadow2 bg-white">
								<div class="container container--narrow pdt-24 pdb-8">
										<div class="t-center t-headline5  t-70">{{memberTotalPoint.present}}</div>
										<!-- <div class="mgt-8 t-center t-body3 t-color-bodyGrayA font-r">{{$t('1894')}}</div> -->
										<div class="mgt-24 d-flex">
											<div class="flex-grow-1 t-center">
												<button v-if="isNoData1" class="t-body4 point active w-48 min-w-48 pdt-8 pdb-7 mgr-8 cursor-pointer" tabindex="0" @click.prevent="moveToAll" @keypress.prevent="moveToAll">
														<span class="mdc-button__label t-body2 font-r" >{{$t('3181')}}</span>
												</button>
												<button v-if="isNoData1" class="t-body4 point  pdl-9 pdr-9 pdt-8 pdb-7 mgr-8 cursor-pointer" tabindex="0" @click.prevent="moveToEarnLose('EARN')" @keypress.prevent="moveToEarnLose('EARN')">
														<span class="mdc-button__label t-body2 font-r">{{$t('1896')}}</span>
												</button>
												<button v-if="isNoData1" class="t-body4 point  pdl-9 pdr-9 pdt-8 pdb-7 cursor-pointer" tabindex="0" @click.prevent="moveToEarnLose('LOSE')" @keypress.prevent="moveToEarnLose('LOSE')">
														<span class="mdc-button__label t-body2 font-r">{{$t('1897')}}</span>
												</button>


												<button v-if="!isNoData1" class="t-body4 point  pdl-9 pdr-9 pdt-8 pdb-7 mgr-8 cursor-pointer"  tabindex="0" @click="moveToAll" @keypress="moveToAll">
														<span class="mdc-button__label t-body2 font-r">{{$t('3181')}}</span>
												</button>
												<button v-if="!isNoData1" class="t-body4 point  pdl-9 pdr-9 pdt-8 pdb-7 mgr-8 cursor-pointer" :class="myStatus=='EARN'?'earned':''" tabindex="0" @click.prevent="moveToEarnLose('EARN')" @keypress.prevent="moveToEarnLose('EARN')">
														<span class="mdc-button__label t-body2 font-r">{{$t('1896')}}</span>
												</button>
												<button v-if="!isNoData1" class="t-body4 point  pdl-9 pdr-9 pdt-8 pdb-7 cursor-pointer" :class="myStatus=='LOSE'?'deducted':''" tabindex="0" @click.prevent="moveToEarnLose('LOSE')" @keypress.prevent="moveToEarnLose('LOSE')">
														<span class="mdc-button__label t-body2 font-r">{{$t('1897')}}</span>
												</button>
											</div>
											<!-- <div
												class="pdl-16 position-relative mdc-menu-anchor menu-container cursor-pointer header-toggle d-flex justify-content-end mgb-24" >
												<button class="mdc-button t-color-bodyGrayA js--dropdown-toggle">
													<div class="mdc-button__ripple"></div>
													<span class="mdc-button__label t-body3 font-r">2020. 06. 10</span>
													<i class="material-icons mdc-button__icon" aria-hidden="true">arrow_drop_down</i>
												</button>
												<div class="mdc-menu mdc-menu-surface toggle-menu">
													<ul class="mdc-list" role="menu" aria-hidden="true" aria-orientation="vertical" tabindex="-1">
														<li class="mdc-list-item" role="menuitem">
															<span class="mdc-list-item__ripple"></span>
															<span class="mdc-list-item__text t-body6 font-r">{{$t('3119')}}</span>
														</li>
														<li class="mdc-list-item" role="menuitem" >
															<span class="mdc-list-item__ripple"></span>
															<span class="mdc-list-item__text t-body6 font-r">{{$t('3120')}}</span>
														</li>
													</ul>
												</div>
											</div> -->
										</div>
										<div class="mgt-30">
												<line-chart :chart-data="graphResult" :height="150"></line-chart>
										</div>
										<div class="divider mgt-8 mgb-8"></div>
										
								</div>
						</div>
						<div class="container container--narrow mgt-30 pdb-50">
								<div class="t-headline7 font-m l-spacing48 mgb-16">{{$t('1898')}}</div>
	        						<div v-for="(pointList, index) in listData" :key="index" class="point-list">
          								<ListItem :pointList="pointList" :myStatus="myStatus"></ListItem>
        						</div>
						</div>
						<infinite-loading  @infinite="fetchData" :identifier="infiniteId" spinner="spiral">
							<div slot="no-more" class="mgt-16"></div>
							<div slot="no-results" class="mgt-16"></div>
						</infinite-loading>
				</main>
</template>

<script>
/**
 * 나의 학습 목록 메인 컴포넌트(my learning main list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCRipple } from "@material/ripple";
import pointApi from "@/api/pointApi.js";
import memberApi from "@/api/memberApi.js";
import campaignApi from "@/api/campaignApi.js";
import ListItem from "./ListItem.vue";
//import NoData from "../common/NoData.vue";
import InfiniteLoading from "vue-infinite-loading";
import LineChart from "./charts/LineChart";

export default {
	components: {
		ListItem,
		//NoData,
		InfiniteLoading,
		LineChart
	},

	data() {
		return {
			status: "",
			isNoData: false,
			isNoData1:true,
			campaignData: null,
			listData: [],
			currentPage: 1,
			totalPages: 1,
			mine: "",
			myStatus: "",
			infiniteId: +new Date(),
			graphResultType:'ALL',
			graphResult: null,
			memberTotalPoint: 0,
		};
	},

	computed: {},

	watch: {
		$route(to, from) {
		// console.log('length=>',this.$router.query.type.length)
		// console.log('to=>',to)
		// console.log('withoutlength=>',to.query.type)
		if(to.query.type.length ==0){
			this.isNoData1= true
		}

		if(to.query.type=='EARN'){
			this.isNoData1= false
		}
		if(to.query.type=='LOSE'){
			this.isNoData1= false
		}

		this.initData();
		this.myStatus = to.query.type;
		
		},
  	},

  	mounted() {
		// 기본 파라미터 설정(set default parameter)
		// console.log('this.$route.query.type mmmm',this.$route.query.type)
		if(this.$route.query.type && this.$route.query.type.length ==0){
			this.isNoData1= true
		}
		
		if(this.$route.query.type=='EARN'){
			this.isNoData1= false
		}
		if(this.$route.query.type=='LOSE'){
			this.isNoData1= false
		}
		
		if (!this.$route.query.type) {
		//this.$router.go(this.$router.currentRoute)  
		this.$router.push('/point').catch(()=>{});
		
		this.myStatus = this.$route.query.type;
		} else {
		this.myStatus = this.$route.query.type;
		}
  	},

	methods: {
		initData() {
			this.listData = [];
			this.currentPage = 1;
			this.totalPages = 1;
			this.infiniteId += 1
		},
		// 목록 데이터 로딩(get list data)
		fetchData($state) {
			let memberTotalPoint = null
				memberApi
					.memberPoint()
					.then((response) => {
						this.memberTotalPoint = response.data.data;
				}).catch((err) => {});

				let graphParams = {
					type: this.$route.query.type,
				}; 
				pointApi
					.getPointForGraph(graphParams)
					.then((response) => {
						let getGraphResponseData = response.data.data;
						this.drawGraph(getGraphResponseData);
				}).catch((err) => {});

			let responseData = null;
			let params = this.setParams();

			if (this.totalPages >= this.currentPage) {

				pointApi
					.pointList(params)
					.then((response) => {
						responseData = response.data.data;
						this.listData = this.listData.concat(responseData.content);
						//console.log('listData=>',this.listData);
						this.currentPage++;
						this.totalPages = responseData.totalPages;

						if (responseData.content.length) {
							$state.loaded();
						} else {
							$state.complete();
						}

						//console.log("nodata", this.listData.length);
						if (this.listData.length > 0) {
							this.isNoData = false;
						} else {
							this.isNoData = true;
						}
						//this.drawGraph(responseData);
					})
					.catch((err) => {
						$state.error();
					});
			} else {
				$state.complete();
			}
		},

		
		drawGraph(res) {
      	let response = res,
			earnPoint = [],
			losePoint = [],
			lables = [];
			
			const graphDates = {};
			// Object.keys(response.point).sort(function(a, b) {
			// 	return a.split('-').reverse().join('').localeCompare(b.split('-').reverse().join(''));
			// }).forEach(function(key) {
			// 	graphDates[key] = response.point[key];
			// })

			Object.keys(response.point).sort(function(a, b) {
				//return a.split('-').reverse().join('').localeCompare(b.split('-').reverse().join(''));
				return (new Date(a)).getTime() - (new Date(b)).getTime();
			}).forEach(function(key) {
				graphDates[key] = response.point[key];
			})
			//console.log('graphDates',graphDates)
			
			for(var i in graphDates){
				//console.log(i); // alerts key
				//console.log(response.point[i][0])
				//alerts key's value
				lables.push(this.$moment(i).format("M/D"));
				if(this.$route.query.type && this.$route.query.type.length ==0){
				earnPoint.push(response.point[i][0].earn);
				losePoint.push(response.point[i][0].lose);
				} else if(this.$route.query.type=='EARN') {
					earnPoint.push(response.point[i][0].earn);
				} else if(this.$route.query.type=='LOSE') {
					losePoint.push(response.point[i][0].lose);
				} else {
				earnPoint.push(response.point[i][0].earn);
				losePoint.push(response.point[i][0].lose);
				}
				
			}
      
			let finalResult = {
				labels: lables,
				datasets: [
				{
				
					//backgroundColor: '#e0b63a',
					//backgroundColor: "rgba(255, 206, 86, 0.2)",
					//borderColor: "rgba(255, 206, 86, 1)",
					lineTension: 0.1,
					backgroundColor: 'rgba(112, 207, 200, 0.1)',
					borderWidth: 3,
					borderColor: '#70cfc8',
					pointHoverBackgroundColor: 'rgba(75,192,192,1)',
					pointHoverBorderColor: 'rgba(220,220,220,1)',
					pointHoverBorderWidth: 2,
					fill: false,
					//borderWidth: 2,
					data: earnPoint
				},
				{
					
					// backgroundColor: '#afd8f8',
					lineTension: 0.1,
					backgroundColor: "rgba(255, 99, 132, 0.2)",
					borderColor: "rgba(255, 99, 132, 1)",
					borderWidth: 3,
					pointHoverBackgroundColor: 'rgba(255, 99, 132, 0.2)',
					pointHoverBorderColor: 'rgba(255, 99, 132, 1)',
					pointHoverBorderWidth: 2,
					fill: false,
					data: losePoint
				}
				]
			};

			this.graphResult = finalResult;
    	},
		
		moveToEarnLose(type){
			//this.$router.push('/point/'+type)
			this.graphResultType = type
			this.$router.push('/point?type='+type)
		},
		moveToAll(){
			this.myStatus=''
			this.graphResultType = 'ALL'
			this.initData();
			this.$router.push('/point').catch(()=>{});
    	},
		setParams() {
			const params = {
				type: this.$route.query.type,
				page: this.currentPage,
				size:10
				
			};
			return params;
		},
	},
};
</script>